import { Box, IconButton, useTheme } from "@mui/material";
import { useContext,useState } from "react";
import { ColorModeContext, tokens } from "../../theme";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
// import SearchIcon from "@mui/icons-material/Search";
import Dropdown from 'react-bootstrap/Dropdown';
import { BsArrowRightSquare, BsFillLockFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import img from "./Images/Biggways_Final_Logo_PNG-02.png"
import { useNavigate } from "react-router-dom";


const Topbar = ({isSidebarCollapsed}) => {

  const navigate =useNavigate()

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const userdat= JSON.parse(localStorage.getItem("LoginDetails")) || [];

  const logout=()=>{
    localStorage.clear();
      window.location.reload(navigate("/"));
  }
  

  return (
   
    
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      bgcolor="#220032" // Set background color
      color="white" // Set text color
      // marginLeft="80px"
      
      
    >
      <Box  display="flex"
        alignItems="center"
        borderRadius="3px"
        // bgcolor="white" // Set background color for search bar
        width="200px"
        p={1} // Adjust the width as needed
        >
      <div className="img" >
          <img src={img} width={"100%"} className="img-fluid"/>

        </div>
     

      </Box>
      
      {/* SEARCH BAR */}
      {/* <Box
        display="flex"
        alignItems="center"
        borderRadius="3px"
        bgcolor="white" // Set background color for search bar
        width="300px" // Adjust the width as needed
        p={1} // Add padding for better appearance
       
      >
        
            
        <IconButton type="button" sx={{ color: colors.grey[400] }}>
          <SearchIcon />
        </IconButton>
        <InputBase
          sx={{ flex: 1, color: colors.grey[400] }}
          placeholder="Search"
        />
      </Box> */}

      {/* ICONS */}
      <Box display="flex" alignItems="center">
        <IconButton
          sx={{ color: "white" }} // Set icon color to white
          onClick={colorMode.toggleColorMode}
        >
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>

        {/* <Dropdown>
          <Dropdown.Toggle variant="primary" id="dropdown-basic">
          <NotificationsOutlinedIcon />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="#/action-1"><PersonOutlinedIcon/> Admin Logged In</Dropdown.Item>
            <Dropdown.Item href="#/action-2"><BsFillLockFill/> Admin Change Password</Dropdown.Item>
            <Dropdown.Divider />
                <Dropdown.Item eventKey="4">View All Notification</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> */}
            {/* <IconButton sx={{ color: "white" }}>
              <SettingsOutlinedIcon />
            </IconButton> */}

            
          
          <Dropdown>
          <Dropdown.Toggle variant="secondary" id="dropdown-basic">
            <PersonOutlinedIcon />{userdat.username}
              
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Link to="/Profile">
              <Dropdown.Item href="/Profile">
                <PersonOutlinedIcon /> My Profile
              </Dropdown.Item>
            </Link>
            <Dropdown.Item  onClick={logout}>
              <BsArrowRightSquare /> Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
    

        {/* <button className="btn btn-danger text-white"onClick={logout}> Welcome - {localStorage.getItem("sellername")} - Logout</button> */}
        
      </Box>
    </Box>
   
  );
};

export default Topbar;

